import { useMutation } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface CheckoutResponse {
    url: string;
    sessionId: string;
}

export function useCheckout() {
    return useMutation<CheckoutResponse, Error, { credits: number }>({
        mutationFn: ({ credits }) =>
            api.post('/api/credits/checkout', { credits }),
    });
}
